import { Stats } from './types';

export const defaultStats: Stats = {
  from: '',
  to: '',
  internEvents: 0,
  campaignEvents: 0,
  notificationEvents: 0,
  totalPendingEvents: 0,
  totalSentEvents: 0,
  totalUndeliveredEvents: 0,
};
